module.exports = __webpack_public_path__ + "static/media/pdr_background.630dbacb.jpg";